import React from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import IconKeyboardArrowRight from '@aboutbits/react-material-icons/dist/IconKeyboardArrowRight'
import {
  Section,
  SectionItem,
  SectionList,
  SectionTitle,
} from '../../../shared/section'
import { useGetActivityById } from '../../activity/db/activities'
import { useGetActivityLink } from '../../activity/utils'

const ReferencedActivity: React.FC<{
  id: string
}> = ({ id }) => {
  const { data: activity } = useGetActivityById(id)
  const link = useGetActivityLink(id)

  return activity && link ? (
    <Section>
      <SectionTitle>
        <FormattedMessage
          id="notification.resource.activity"
          defaultMessage="Activity"
        />
      </SectionTitle>
      <SectionList>
        <Link to={link} className="block">
          <SectionItem>
            <h2 className="flex-1">{activity.name}</h2>
            <IconKeyboardArrowRight className="size-6" />
          </SectionItem>
        </Link>
      </SectionList>
    </Section>
  ) : null
}

export { ReferencedActivity }
